const noticeList = {
  "id|+1": 1,
  title: "@ctitle(10, 30)",
  create_at: "@datetime",
}

export default noticeList
